<template>

    <div class="field has-addons">

        <div class="control is-expanded" v-show=" ! editing ">
            <input :placeholder="placeholder" :type="type" :name="name" class="input" readonly :value="target"/>
        </div>
        <div class="control" v-show=" ! editing ">
            <button class="button" type="button" @click=" startEdit ">
                <i class="fas fa-pen"></i>
            </button>
        </div>

        <div class="control is-expanded" v-show=" editing ">
            <input :placeholder="placeholder" type="text" ref="editableTarget" :id="id" :name="name" class="input" @keyup="dataInputted" v-model="target"/>
        </div>
        <div class="control" v-show=" editing ">
            <button :disabled=" loading " class="button is-primary" type="button" @click=" submitForm ">
                <i class="fas fa-save"></i>
            </button>
        </div>

    </div>

</template>

<script>
    export default {
        name: 'Input-Editable',
        props: {
            name: {
                type: String,
                required: true,
            },
            type: {
                type: String,
                required: false,
                default: 'text'
            },
            routeSave: {
                type: String,
                required: true,
            },
            method: {
                type: String,
                required: false,
                default: 'POST'
            },
            id: {
                type: String,
                required: false,
            },
            value: {
                type: String|Number,
                required: false,
            },
            placeholder: {
                type: String,
                required: false,
            }
        },
        data() {
            return {
                editing: false,
                target: this.value,
                loading: false,
            };
        },
        methods: {
            startEdit: function () {
                this.editing = true;
                this.$nextTick(function() {
                    this.$refs.editableTarget.focus();
                });
            },
            dataInputted: function (data) {
                if (data.keyCode === 13) {
                    this.submitForm();
                } else {
                    this.$emit('input', data);
                }
            },
            submitForm: function () {
                this.loading = true;

                let data = {
                    _method: this.method,
                    _token: this.$store.state.csrfToken
                };
                data[this.name] = this.target;

                this.$http.post(this.routeSave, data)
                    .then(response => {
                        this.$d('response');
                        this.$d(response);
                        if (response.data.hasErrors) {
                            this.$store.commit('errors', response.data.errors);
                        } else if (response.data.success === true) {
                            this.editing = false;
                            this.$store.commit('success', 'Successfully Updated');
                            this.$emit('changed', this.target)
                        } else {
                            this.$store.commit('error', response.data.message);
                        }
                        this.loading = false;
                    })
                    .catch(error => {
                        this.$displayError(error);
                        this.loading = false;
                    });
            }
        },
        mounted() {
            this.$emit('mounted');
        }

    }
</script>
